<div class="content-box">
  <app-breadcrumb pagina="Login"></app-breadcrumb>

  <section class="login" aria-labelledby="login-titulo">
    <div class="login-cartao">
      <app-login-card [nivelTitulo]="1" [destino]="destinoSeguro()"></app-login-card>

      <img
        class="login-ilustracao"
        ngSrc="assets/images/img-tela-login.png"
        width="560"
        height="560"
        priority
        alt=""
      />
    </div>
  </section>
</div>
